(function () {
  try {
    // ==================================================
    // ⚙️ CONFIG
    // ==================================================
    const PARAM_NAME = window.cartTransferParam || "cart_from_A";
    const SHOP_A_URL = (window.originShopAUrl || "https://vestiaire2luxe.com").replace(/\/+$/, "");
    const CHECKOUT_PATH = "/checkout"; // Shopify checkout

    // ==================================================
    // 🔎 DÉTECTION ARRIVÉE DEPUIS A
    // ==================================================
    const url = new URL(window.location.href);
    const rawParam = url.searchParams.get(PARAM_NAME);

    function failBackToShopA(reason) {
      console.warn("[B2] Transfert panier échoué:", reason);
      try {
        // Optionnel : tu peux passer un message à A
        const back = new URL(SHOP_A_URL);
        back.searchParams.set("b2_error", String(reason || "unknown").slice(0, 200));
        window.location.replace(back.toString());
      } catch (e) {
        window.location.replace(SHOP_A_URL);
      }
    }

    // ==================================================
    // 🟢 CAS 1 — ARRIVÉE DEPUIS A
    // ==================================================
    if (rawParam) {
      // --- Loader ---
      const style = document.createElement("style");
      style.id = "b2-loader-style";
      style.textContent = `
        #b2-loader {
          position: fixed;
          inset: 0;
          z-index: 2147483647;
          background: #ffffff;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;
          font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
          color: #1a1a1a;
          opacity: 1;
          transition: opacity 0.45s ease-out;
          pointer-events: none;
        }
        #b2-loader .loader-container {
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 28px;
        }
        #b2-loader .logo {
          width: 110px;
          height: auto;
          animation: b2pulse 1.8s ease-in-out infinite;
        }
        #b2-loader .loader-text {
          font-size: 16px;
          font-weight: 600;
          letter-spacing: 0.2px;
          color: #111;
          margin: 0;
          text-align: center;
        }
        #b2-loader .loader-subtext {
          font-size: 14px;
          color: #666;
          margin-top: 8px;
          font-weight: 400;
          text-align: center;
        }
        #b2-loader .progress-bar {
          width: 190px;
          height: 3px;
          background: #ebebeb;
          border-radius: 2px;
          overflow: hidden;
          margin-top: 10px;
        }
        #b2-loader .progress-fill {
          height: 100%;
          width: 0%;
          background: #000;
          border-radius: 2px;
          animation: b2progress 1.9s ease-in-out infinite;
        }
        @keyframes b2pulse {
          0%, 100% { opacity: 0.82; transform: scale(1); }
          50% { opacity: 1; transform: scale(1.05); }
        }
        @keyframes b2progress {
          0% { width: 0%; }
          50% { width: 72%; }
          100% { width: 100%; }
        }
        #b2-loader.hidden { opacity: 0; }
        html, body { overflow: hidden !important; height: 100% !important; }
      `;
      document.head.appendChild(style);

      const loader = document.createElement("div");
      loader.id = "b2-loader";
      loader.innerHTML = `
        <div class="loader-container">
          <img
            src="https://vestiaire2luxe.com/cdn/shop/files/Gemini_Generated_Image_qd8zvcqd8zvcqd8z-removebg-preview.png?v=1764971682&width=300"
            alt="Logo"
            class="logo"
          >
          <div>
            <p class="loader-text">Redirection vers le paiement</p>
            <p class="loader-subtext">Import sécurisé du panier…</p>
          </div>
          <div class="progress-bar"><div class="progress-fill"></div></div>
        </div>
      `;
      document.documentElement.appendChild(loader);

      const startTime = Date.now();
      function hideLoader(cb) {
        const elapsed = Date.now() - startTime;
        const minDelay = 700; // ✅ rapide (ajuste si tu veux)
        const delay = Math.max(minDelay - elapsed, 0);

        setTimeout(() => {
          loader.classList.add("hidden");
          document.documentElement.style.overflow = "";
          document.body.style.overflow = "";

          setTimeout(() => {
            if (loader && loader.parentNode) loader.parentNode.removeChild(loader);
            if (style && style.parentNode) style.parentNode.removeChild(style);
            if (typeof cb === "function") cb();
          }, 480);
        }, delay);
      }

      // --- Decode payload ---
      let signed;
      try {
        signed = JSON.parse(decodeURIComponent(rawParam));
      } catch (e) {
        hideLoader(() => failBackToShopA("Parse cart_from_A impossible"));
        return;
      }

      if (!signed?.d?.items?.length) {
        hideLoader(() => failBackToShopA("Payload invalide (items manquants)"));
        return;
      }

      const itemsFromA = signed.d.items;

      // Nettoie l’URL pour éviter re-run si refresh
      url.searchParams.delete(PARAM_NAME);
      window.history.replaceState({}, "", url.toString());

      const normalize = (str) =>
        String(str || "")
          .toLowerCase()
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "")
          .trim();

      (async function () {
        try {
          // 1) vider panier B
          await fetch("/cart/clear.js", { method: "POST" });

          // 2) reconstruire panier B
          for (const item of itemsFromA) {
            const handle = item.h;
            const qty = Math.max(1, Number(item.q || 1));
            const wantedOptions = (item.o || []).map(normalize).filter(Boolean);

            if (!handle) continue;

            const prodResp = await fetch(`/products/${handle}.js`, { cache: "no-store" });
            if (!prodResp.ok) {
              hideLoader(() => failBackToShopA("Produit introuvable: " + handle));
              return;
            }

            const product = await prodResp.json();

            const variant = (product.variants || []).find(v => {
              const opts = [v.option1, v.option2, v.option3].filter(Boolean).map(normalize);
              return !wantedOptions.length || wantedOptions.every(o => opts.includes(o));
            });

            if (!variant?.id) {
              hideLoader(() => failBackToShopA("Variante introuvable: " + handle));
              return;
            }

            const addResp = await fetch("/cart/add.js", {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({ id: variant.id, quantity: qty })
            });

            if (!addResp.ok) {
              hideLoader(() => failBackToShopA("Erreur ajout panier: " + handle));
              return;
            }
          }

          // 3) check panier
          const cartB = await fetch("/cart.js", { cache: "no-store" }).then(r => r.json());
          if (!cartB?.items?.length) {
            hideLoader(() => failBackToShopA("Panier vide après import"));
            return;
          }

          // 4) redirect checkout Shopify
          window.location.replace(CHECKOUT_PATH);
        return;

        } catch (err) {
          hideLoader(() => failBackToShopA("Erreur JS: " + (err?.message || String(err))));
        }
      })();

      return;
    }

    // ==================================================
    // 🟦 CAS 2 — ARRIVÉE NORMALE SUR B
    // 👉 plus d’interception checkout / Square
    // ==================================================
    // Rien à faire.

  } catch (err) {
    console.error("[B2] Erreur fatale init", err);
    try {
      const SHOP_A_URL = (window.originShopAUrl || "https://vestiaire2luxe.com").replace(/\/+$/, "");
      window.location.replace(SHOP_A_URL);
    } catch (e) {}
  }
})();
